export default "__VITE_ASSET__5PPRX0rc__"